<template>
  <div class="content">
    <div class="layout">
      <div class="d-flex justify-content-center">
        <div class="text-end me-3" style="width: 100%; max-width: 100%">
          <!-- Button to open dialog -->
          <button class="btn btn-primary" @click="showDialog = true">
            Add Page Accordion
          </button>
        </div>
      </div>
    </div>

    <!-- Dialog for Title and Description -->
    <div v-if="showDialog" class="dialog-overlay">
      <div class="dialog">
        <div class="text-end">
          <button
            class="btn text-danger"
            @click="closeDialog"
            style="font-size: 2rem"
          >
            &times;
          </button>
        </div>
        <h3>Enter Title and Description</h3>
        <input
          v-model="title"
          class="form-control mb-2 p-2"
          placeholder="Enter title"
          type="text"
        />
        <textarea
          style="height: 200px"
          v-model="description"
          class="form-control mb-2 p-2"
          placeholder="Enter description"
          rows="4"
        ></textarea>
        <div class="text-center m-3">
          <button
            class="btn btn-success"
            style="background-color: green; color: white"
            @click="saveContent"
          >
            Save
          </button>
          <button class="btn btn-danger m-3" @click="closeDialog">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Accordion for displaying FAQ items -->
    <div
      v-if="contentList && contentList.length"
      class="accordion"
      id="accordionPanelsStayOpenExample"
    >
      <div
        v-for="(item, index) in contentList"
        :key="index"
        class="accordion-item"
      >
        <h2 class="accordion-header" :id="'panelsStayOpen-heading' + index">
          <button
            class="accordion-button"
            type="button"
            :data-bs-toggle="'collapse'"
            :data-bs-target="'#panelsStayOpen-collapse' + index"
            :aria-expanded="expandedIndex === index ? 'true' : 'false'"
            :aria-controls="'panelsStayOpen-collapse' + index"
            @click="toggleAccordion(index)"
          >
            {{ item.title }}
          </button>
        </h2>
        <div
          :id="'panelsStayOpen-collapse' + index"
          class="accordion-collapse collapse"
          :class="{ show: expandedIndex === index }"
          :aria-labelledby="'panelsStayOpen-heading' + index"
        >
          <div class="accordion-body">
            <p>{{ item.description }}</p>

            <!-- Edit and Delete buttons -->
            <div class="d-flex justify-content-end mt-2">
              <button
                class="btn btn-warning btn-sm m-1"
                @click="editContent(index)"
              >
                Edit
              </button>
              <button
                class="btn btn-danger btn-sm m-1"
                @click="deleteContent(item.id)"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-center">No Page Accordion</div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      title: "",
      description: "",
      contentList: [],
      loading: false,
      showDialog: false,
      expandedIndex: null,
      delLoading: true,
      page_id: null,
    };
  },
  mounted() {
    const schemaId = this.$route.params.id;
    this.page_id = schemaId;
    this.getContent(schemaId);
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
      this.title = "";
      this.description = "";
    },
    async saveContent() {
      if (!this.title || !this.description) {
        this.$notify({
          message: "Please enter both title and description",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        const response = await axios.post(
          `/acc-page/${this.page_id}`,
          { title: this.title, description: this.description },
          { headers: { "api-key": `${Cookies.get("authToken")}` } }
        );

        if (response.status === 201) {
          this.$notify({
            message: "Title and description saved successfully",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.closeDialog();
        this.getContent();
      }
    },
    async editContent(index) {
      const item = this.contentList[index];
      this.title = item.title;
      this.description = item.description;
      this.showDialog = true;
      // You can add further update logic here
    },
    async deleteContent(id) {
      try {
        this.delLoading = true;
        const response = await axios.delete(`/acc-page/${id}`, {
          headers: { "api-key": `${Cookies.get("authToken")}` },
        });

        if (response.status === 200) {
          this.$notify({
            message: "Content deleted successfully",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.delLoading = false;
        this.getContent();
      }
    },
    async getContent(schemaId) {
      try {
        const response = await axios.get(`/acc-page/${this.page_id}`, {
          headers: { "api-key": `${Cookies.get("authToken")}` },
        });

        if (response.status === 200) {
          this.contentList = response.data.data;
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    toggleAccordion(index) {
      if (this.expandedIndex === index) {
        this.expandedIndex = null;
      } else {
        this.expandedIndex = index;
      }
    },
    handleError(error) {
      const message =
        error.response?.data?.message || error.response?.data?.error_message;
      this.$notify({
        message,
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
      });
    },
  },
};
</script>

<style scoped>
/* Dialog Styling */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1060;
}

/* Accordion Styling */
.accordion-button {
  color: #333;
  background-color: #f7f7f7;
  border: 1px solid #ddd;
}

.accordion-button:not(.collapsed) {
  color: #000000;
  /* background-color: #007bff; */
  /* border-color: #0056b3; */
}

.accordion-body {
  padding: 10px;
}

button {
  font-size: 0.875rem;
}

.d-flex {
  display: flex;
  justify-content: flex-end;
}

.m-1 {
  margin: 0.5rem;
}
</style>
